// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"369ff096","156":"d82ad6a8","338":"f7460cfb","453":"2513891a","551":"5a29c561","645":"3fc256c0","842":"803857ec"}[chunkId] + ".chunk.js";
};